"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12127],{

/***/ 12127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70821);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(333);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64435);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83153);
/* harmony import */ var hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64999);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70362);
/* harmony import */ var lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89790);
/* harmony import */ var global_Securities_stores_useSearchCompanyModalStore__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5612);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(60374);
/* harmony import */ var _Search__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39809);
/* harmony import */ var _Navbar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44554);
/* harmony import */ var _Message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27271);
/* harmony import */ var _Notification__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(25045);
/* harmony import */ var _ProfileMenu__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97513);
/* harmony import */ var _SearchCompanyModal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(80567);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(46990);






// header components















var Mobile = function() {
    var data = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_5__/* .selectors */ .wl).data;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,global_Securities_stores_useSearchCompanyModalStore__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(s) {
        return [
            s.visible,
            s.closeModal
        ];
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z), 2), isShowSearchCompanyModal = ref[0], closeSearchCompanyModal = ref[1];
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_6__/* .selectors */ .wl).isLoggedIn;
    var isRealTrading = (0,hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().isRealTrading;
    var showTradingModal = (0,global_TradingModal_store__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(s) {
        return s.showModal;
    });
    var getUnreadCount = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_10__/* .useNotificationData */ .z)(function(store) {
        return store.getUnreadCount;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isLoggedIn) {
            getUnreadCount();
        }
    }, []);
    var onSymbolChange = function(newSymbol) {
        closeSearchCompanyModal();
        showTradingModal({
            symbol: newSymbol,
            orderType: isRealTrading ? constants_trading__WEBPACK_IMPORTED_MODULE_7__/* .ORDER_TYPE.BUY */ .Jm.BUY : constants_trading__WEBPACK_IMPORTED_MODULE_7__/* .ORDER_TYPE.VIRTUAL_BUY */ .Jm.VIRTUAL_BUY
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .HeaderMobile */ .GP, {
        id: "stockbit-header-mobile",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Navbar__WEBPACK_IMPORTED_MODULE_13__/* .Mobile */ .i, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Search__WEBPACK_IMPORTED_MODULE_12__/* .Mobile */ .i, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    !data.ispro ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: "/shop",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .ProUser */ .cA, {
                            children: "Berlangganan Pro"
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Message__WEBPACK_IMPORTED_MODULE_14__/* .Mobile */ .i, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Notification__WEBPACK_IMPORTED_MODULE_15__/* .Mobile */ .i, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProfileMenu__WEBPACK_IMPORTED_MODULE_16__/* .Mobile */ .i, {})
                ]
            }),
            isShowSearchCompanyModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchCompanyModal__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                onSymbolChange: function(symbol) {
                    return onSymbolChange(symbol);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Mobile);


/***/ })

}]);